import { ArrowRight, Calendar, Clock, User } from "lucide-react";
import FadeInSection from "../../ui/fade-in-section";

export default function SessionsUpcoming({ upcoming, loading }) {
  if (loading) {
    return (
      <section className="relative overflow-hidden">
        <div className="h-48 sm:h-56 bg-[#10263f] animate-pulse" />
      </section>
    );
  }

  if (!upcoming?.title) return null;

  return (
    <section className="relative overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(135deg, #16344f 0%, #10263f 45%, #0c1d32 100%)",
        }}
        aria-hidden
      />
      <div
        className="absolute -top-24 right-0 w-[28rem] h-[28rem] rounded-full bg-[#14B48C]/20 blur-3xl"
        aria-hidden
      />

      <div className="page-container relative z-10 py-10 sm:py-12 lg:py-14">
        <FadeInSection>
          <div className="grid grid-cols-1 lg:grid-cols-[1.15fr_0.85fr] gap-6 lg:gap-8 items-stretch">
            <div className="min-w-0 flex flex-col justify-center">
              <p className="text-[11px] sm:text-xs font-semibold tracking-[0.18em] uppercase text-[#14B48C] mb-3">
                Upcoming Session
              </p>
              <h2 className="text-[1.65rem] sm:text-2xl lg:text-[1.85rem] font-bold text-white leading-snug text-balance">
                {upcoming.title}
              </h2>
              {upcoming.description ? (
                <p className="mt-3 text-white/70 text-[14px] sm:text-[15px] leading-[1.55]">
                  {upcoming.description}
                </p>
              ) : null}
            </div>

            <div className="w-full h-full rounded-2xl bg-white/10 border border-white/10 p-5 sm:p-6 flex flex-col justify-between gap-5">
              <div className="flex flex-col gap-4">
                {upcoming.date ? (
                  <div className="flex items-start gap-3">
                    <Calendar className="w-5 h-5 text-[#14B48C] shrink-0 mt-0.5" aria-hidden />
                    <p className="text-white text-sm sm:text-[15px] font-medium leading-snug">
                      {upcoming.date}
                    </p>
                  </div>
                ) : null}
                {upcoming.time ? (
                  <div className="flex items-start gap-3">
                    <Clock className="w-5 h-5 text-[#14B48C] shrink-0 mt-0.5" aria-hidden />
                    <p className="text-white text-sm sm:text-[15px] font-medium leading-snug">
                      {upcoming.time}
                    </p>
                  </div>
                ) : null}
                {upcoming.speaker ? (
                  <div className="flex items-start gap-3">
                    <User className="w-5 h-5 text-[#14B48C] shrink-0 mt-0.5" aria-hidden />
                    <p className="text-white text-sm sm:text-[15px] font-medium leading-snug">
                      {upcoming.speaker}
                    </p>
                  </div>
                ) : null}
              </div>

              {upcoming.registrationLink ? (
                <a
                  href={upcoming.registrationLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 w-full px-6 py-3.5 rounded-xl bg-[#14B48C] hover:bg-[#11997A] text-white font-semibold shadow-lg shadow-[#14B48C]/25 transition-colors"
                >
                  Register Free
                  <ArrowRight className="w-5 h-5" aria-hidden />
                </a>
              ) : null}
            </div>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
